/**
 * 优化api模块引入方式
 * 自动引入modules文件夹中的所有module模块
 * https://webpack.js.org/guides/dependency-management/#requirecontext
 * */

const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export default modules



// WEBPACK FOOTER //
// ./src/api/index.js